import { withRBAC } from "../../../rbac";
import { PayrollRunCreate } from "./Create";
import { PayrollRunList } from "./List";
import { PayrollRunShow } from "./Show";

export const payrollRuns = {
  list: withRBAC(PayrollRunList, "view_hr"),
  show: withRBAC(PayrollRunShow, "view_hr"),
  create: withRBAC(PayrollRunCreate, "process_payroll"),
};
